module.exports = __webpack_public_path__ + "img/car-turret-shadow.c882789d.png";